import { render, staticRenderFns } from "./MobileTradingTerminalPage.vue?vue&type=template&id=2b794554&scoped=true"
import script from "./MobileTradingTerminalPage.vue?vue&type=script&lang=js"
export * from "./MobileTradingTerminalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b794554",
  null
  
)

export default component.exports